import React, { useState, useEffect, useCallback, useRef } from 'react';
import { useParams } from 'react-router-dom';

import Table from '@base/Table';
import Toast from '@base/Toast';
import VisualizarDEDialog from './VisualizarDEDialog';

import CardIcon from '@material-ui/icons/LibraryBooks';

import {
  verifyPagingAndSorting,
  PAGE,
  SIZE,
  ASC,
  TOTAL_ELEMENTS,
  TOTAL_PAGES,
} from '@base/Table/Utils';

import { removePagingAndSorting } from '@helpers/PaginationHelper';
import { ProcessoResolver } from '@helpers/ProcessoHelper';

import DocumentoEnvioService from '@services/DocumentoEnvioService';
import ObjetoPostalService from '@services/ObjetoPostalService';

export const DocumentoEnvioTableView = (props) => {

  const processo = ProcessoResolver(useParams().processo);
  const [blob, setBlob] = useState();
  const [loading, setLoading] = useState(true);
  const [openDialogVisualizarDE, setOpenDialogVisualizarDE] = useState(false);
  const [page, setPage] = useState(PAGE);
  const [size, setSize] = useState(props.size ? props.size : SIZE);

  const [defaultOrderBy,] = useState('id');
  const [sort, setSort] = useState([{ orderBy: defaultOrderBy, order: ASC }])
  const [totalElements, setTotalElements] = useState(TOTAL_ELEMENTS);
  const [totalPages, setTotalPages] = useState(TOTAL_PAGES);
  const [list, setList] = useState([]);

  const toastRef = useRef(null);
  const dialogVisualizarDERef = useRef(null);

  let columns = [
    { label: 'ID', name: 'id', func: null, key: true },
    { label: 'Escola', name: 'escola', func: null, key: false },
    { label: 'Qtd de Cartões N1', name: 'qtdeCartoesN1', func: null, key: false },
    { label: 'Qtd de Cartões N2', name: 'qtdeCartoesN2', func: null, key: false },
    { label: 'Qtd de Cartões N3', name: 'qtdeCartoesN3', func: null, key: false },
    { label: 'Origem', name: 'origem', func: null, key: false },
  ];

  const handlePage = page => { setPage(page); props.setFiltroAtivo(true); };
  const handleRowsPerPage = (size, page) => { setPage(page); setSize(size); props.setFiltroAtivo(true); };
  const verifyOrderBy = (orderBy) => {
    if (orderBy === 'id') {
      return 'id';
    } else {
      return orderBy;
    }
  };

  const handleSort = (orderBy, order) => {
    if (sort.find(s => s.orderBy === verifyOrderBy(orderBy))) {
      let newSort = sort.filter(s => s.orderBy !== verifyOrderBy(orderBy));
      newSort.splice(sort.indexOf(sort.find(s => s.orderBy === verifyOrderBy(orderBy))), 0, { orderBy: verifyOrderBy(orderBy), order: order })
      setSort([...newSort]);
    } else {
      setSort([...sort.filter(s => s.orderBy !== verifyOrderBy(orderBy)), { orderBy: verifyOrderBy(orderBy), order: order }]);
    }
    props.setFiltroAtivo(true);
  }

  const handleClearSort = (orderBy) => {
    props.setFiltroAtivo(true);
    orderBy ? setSort([...sort.filter(s => s.orderBy !== verifyOrderBy(orderBy))]) : setSort([{ orderBy: defaultOrderBy, order: ASC }])
  };

  const handleTotalPages = () => totalPages;
  const handleTotalElements = () => totalElements;

  const downloadArquivo = (id) => {
		ObjetoPostalService.downloadDE(processo.id, id)
      .then(resultado => {
        setBlob(resultado.data);
        setOpenDialogVisualizarDE(true);
      }).catch(erro => {
			  toastRef.current.show('error', 'Não foi posível fazer download do arquivo.');
		  });

	}

  let actions = [
    {
			func: (id) => downloadArquivo(id),
			icon: <CardIcon />,
			disabled: () => false,
			name: () => "Visualizar DE"
		}
  ];

  const carregarDados = useCallback(() => {

    const f = verifyPagingAndSorting(removePagingAndSorting(props.filtros), page, size, sort, props.filtroAtivo);

    DocumentoEnvioService.filtrar(processo.id, f).then(resultado => {

      let { content, number, size, totalElements, totalPages } = resultado.data;

      setList(content);
      setPage(number);
      setSize(size);
      setTotalElements(totalElements);
      setTotalPages(totalPages);
      setLoading(false);

    }).catch(error => toastRef.current.show("error", "Ocorreu um Problema ao Realizar os Filtros!"));
  }, [props.filtros, props.filtroAtivo, size, page, sort, processo]);

  useEffect(() => carregarDados(), [carregarDados]);

  return (
    <>
      <Toast ref={toastRef} />

      <Table
        columns={columns}
        tableData={list}
        actions={actions}
        page={page}
        handlePage={handlePage}
        handleTotalPages={handleTotalPages}
        handleTotalElements={handleTotalElements}
        rowsPerPage={size}
        handleRowsPerPage={handleRowsPerPage}
        sort={sort}
        handleSort={handleSort}
        handleClearSort={handleClearSort}
        loading={loading}
      />

      {openDialogVisualizarDE &&
        <VisualizarDEDialog
					aoFechar={() => setOpenDialogVisualizarDE(false)}
					aberto={openDialogVisualizarDE}
					blob={blob}
					ref={dialogVisualizarDERef}
				/> }

    </>
  );
}

export default DocumentoEnvioTableView;
